import { Injectable } from '@angular/core';
import * as Tooltip from "../../assets/js/popper-tooltip.min";

@Injectable()
export class UtilsService {

  constructor() { }

  setTooltips(): void{
    document.body.style.cursor = 'pointer';
    var tooltips = [];
    var tooltipElements = document.getElementsByClassName("as-tooltip-trigger");
    for(var i = 0; i < tooltipElements.length; i++) {
      var element = tooltipElements.item(i),
        text = element.getAttribute('data-tooltip-text');
      tooltips.push(new Tooltip(element, {
        placement: 'top',
        container: document.body,
        html: true,
        title: text,
        trigger: 'hover',
        template: '<div class="tooltip as-tooltip" role="tooltip"><div class="tooltip-arrow as-tooltip__arrow"></div><div class="tooltip-inner as-tooltip__inner"></div></div>'.trim()
      }));
    }
    // TODO
    // if you want scroll to top call
    window.scrollTo(0, 0);
    return;
  }
}
